function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.21 20.32l-4.78-4.77a10 10 0 1 0-2.88 2.88l4.77 4.78a1.1 1.1 0 0 0 1.56 0l1.33-1.33a1.1 1.1 0 0 0 0-1.56zm-18-5.49a6.77 6.77 0 1 1 9.58 0 6.73 6.73 0 0 1-9.54 0z",
  fill: "#fff"
});

var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.53 23.53"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMuNTMgMjMuNTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTIzLjIxIDIwLjMyLTQuNzgtNC43N2ExMCAxMCAwIDEgMCAtMi44OCAyLjg4bDQuNzcgNC43OGExLjEgMS4xIDAgMCAwIDEuNTYgMGwxLjMzLTEuMzNhMS4xIDEuMSAwIDAgMCAwLTEuNTZ6bS0xOC01LjQ5YTYuNzcgNi43NyAwIDEgMSA5LjU4IDAgNi43MyA2LjczIDAgMCAxIC05LjU0IDB6IiBmaWxsPSIjZmZmIi8+PC9zdmc+";
export { SvgIconSearch as ReactComponent };